<template>
  <AddBidderTeamProjectModal
    v-if="showAddBidderTeamProjectModal"
    :projectId="projectId"
    :projectBidderId="projectBidderIdSelected"
    @closeModal="closeModal"
  />
  <EditBidderTeamProjectModal
    v-if="showEditBidderTeamProjectModal"
    :projectId="projectId"
    :projectBidderId="projectBidderIdSelected"
    :projectBidderTeamId="projectBidderTeamIdSelected"
    @closeModal="closeModal"
  />
  <DeleteBidderTeamProjectModal
    v-if="showDeleteBidderTeamProjectModal"
    :projectId="projectId"
    :projectBidderId="projectBidderIdSelected"
    :projectBidderTeamId="projectBidderTeamIdSelected"
    @closeModal="closeModal"
  />
  <CreateEditUserTeamModal
    v-if="showCreateEditUserModal"
    :userId="userIdSelected"
    @closeModal="closeModal"
  />
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header py-0">
      <h6 class="py-3 mb-0">Equipe Técnica - Proponentes</h6>
    </div>
    <div class="card-body pb-1">
      <div v-if="bidders.length > 0">
        <div v-for="bidder in bidders" :key="bidder.id">
          <div
            class="card border-start border-start-width-2 border-start-secondary p-2"
          >
            <div class="row">
              <div class="col-6"><h6>Dados do Proponente</h6></div>
              <div v-if="canEditProject" class="col-6 text-end">
                <span
                  role="button"
                  class="badge bg-primary"
                  title="Adicionar Equipe Técnica ao Proponente"
                  @click="addBidderTeamProject(bidder.id)"
                >
                  Adicionar
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <p><strong>Nome:</strong> {{ bidder.bidderPartnerName }}</p>
              </div>
              <div class="col-sm-4">
                <p><strong>CNPJ:</strong> {{ bidder.bidderPartnerCnpj }}</p>
              </div>
              <div class="col-sm-4">
                <p>
                  <strong>Responsável:</strong> {{ bidder.responsibleName }}
                </p>
              </div>
            </div>
            <hr class="mt-1 mb-2" />
            <h6>Equipe Técnica</h6>
            <ListBidderTeamsProject
              :projectId="projectId"
              :projectBidderId="bidder.id"
              :reloadListBidderTeams="reloadListBidderTeams"
              @reloadListBidderTeams="reloadListBidderTeams = false"
              @editBidderTeamProject="editBidderTeamProject"
              @deleteBidderTeamProject="deleteBidderTeamProject"
              @editUser="editUser"
            />
          </div>
        </div>
      </div>
      <div v-else>
        <p class="text-center">
          Este sumário executivo não possui nenhum proponente vinculado
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import AddBidderTeamProjectModal from '@/components/projects/bidders/teams/AddBidderTeamProjectModal.vue'
import EditBidderTeamProjectModal from '@/components/projects/bidders/teams/EditBidderTeamProjectModal.vue'
import DeleteBidderTeamProjectModal from '@/components/projects/bidders/teams/DeleteBidderTeamProjectModal.vue'
import CreateEditUserTeamModal from '@/components/users/CreateEditUserTeamModal.vue'
import ListBidderTeamsProject from '@/components/projects/bidders/teams/ListBidderTeamsProject.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'BiddersTeamsProject',

  components: {
    AddBidderTeamProjectModal,
    EditBidderTeamProjectModal,
    DeleteBidderTeamProjectModal,
    CreateEditUserTeamModal,
    LoadingData,
    ListBidderTeamsProject,
  },

  props: {
    projectId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      reloadListBidderTeams: false,
      showAddBidderTeamProjectModal: false,
      showEditBidderTeamProjectModal: false,
      showDeleteBidderTeamProjectModal: false,
      showCreateEditUserModal: false,
      bidders: [],
      projectBidderIdSelected: null,
      projectBidderTeamIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['canEditProject']),
  },

  methods: {
    async getBidders() {
      try {
        this.bidders = await this.$store.dispatch(
          'getProjectBidders',
          this.projectId,
        )
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    addBidderTeamProject(projectBidderId) {
      this.projectBidderIdSelected = projectBidderId || null
      this.showAddBidderTeamProjectModal = true
    },

    editBidderTeamProject(bidderTeam) {
      this.projectBidderIdSelected = bidderTeam.projectBidderId
      this.projectBidderTeamIdSelected = bidderTeam.projectBidderTeamId
      this.showEditBidderTeamProjectModal = true
    },

    deleteBidderTeamProject(bidderTeam) {
      this.projectBidderIdSelected = bidderTeam.projectBidderId
      this.projectBidderTeamIdSelected = bidderTeam.projectBidderTeamId
      this.showDeleteBidderTeamProjectModal = true
    },

    editUser(userId) {
      this.userIdSelected = userId
      this.showCreateEditUserModal = true
    },

    closeModal(loadListBidderTeams) {
      if (loadListBidderTeams) {
        this.reloadListBidderTeams = true
      }
      this.showAddBidderTeamProjectModal = false
      this.showEditBidderTeamProjectModal = false
      this.showDeleteBidderTeamProjectModal = false
      this.showCreateEditUserModal = false
    },
  },

  mounted() {
    this.getBidders()
  },
}
</script>
